let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8Lh9U")).then(() => parcelRequire('kqZOw'));